import Timeout from 'await-timeout';
import tippy from 'tippy.js';

const initialize = (element, options = {}) => {
    const {
        autoHideDelay = 2000,
        ...tippyOptions
    } = options;

    return tippy(
        element,
        {
            content: 'Copied!',
            arrow: true,
            animation: 'shift-away',
            trigger: 'click',
            hideOnClick: false,
            zIndex: 1,
            onShow: async (instance) => {
                if (autoHideDelay === null) {
                    return;
                }

                await Timeout.set(autoHideDelay);
                instance.hide();
            },
            ...tippyOptions,
        }
    );
};

export default {
    initialize,
};
